import React, { Component } from "react"
import Button from "@material-ui/core/Button"
import FormControlLabel from "@material-ui/core/FormControlLabel"
import { Link } from "react-router-dom"
import Grid from "@material-ui/core/Grid"
import Typography from "@material-ui/core/Typography"
import Container from "@material-ui/core/Container"
import { withStyles } from "@material-ui/core"
import { Cookies } from "react-cookie"
import { Alert, AlertTitle } from "@material-ui/lab"
import { Redirect } from "react-router-dom"
import Paper from "@material-ui/core/Paper"
import Table from "@material-ui/core/Table"
import TableBody from "@material-ui/core/TableBody"
import TableCell from "@material-ui/core/TableCell"
import TableContainer from "@material-ui/core/TableContainer"
import TableHead from "@material-ui/core/TableHead"
import TablePagination from "@material-ui/core/TablePagination"
import TableRow from "@material-ui/core/TableRow"
import JDate from "jalali-date"
import Switch from "@material-ui/core/Switch"
import Snackbar from "@material-ui/core/Snackbar"
import * as constants from "../constants"
import Divider from "@material-ui/core/Divider"
import TableSortLabel from "@material-ui/core/TableSortLabel"
import Moment from "moment"
import NumberFormat from "react-number-format"
import HighlightOffIcon from "@material-ui/icons/HighlightOff"
import {$POST} from './../func'
import Collapse from "@material-ui/core/Collapse"
import Avatar from "@material-ui/core/Avatar"

import "react-modern-calendar-datepicker/lib/DatePicker.css"
import Calendar from "react-modern-calendar-datepicker"
import OutlinedInput from "@material-ui/core/OutlinedInput"
import IconButton from "@material-ui/core/IconButton"
import InputAdornment from "@material-ui/core/InputAdornment"
import FloatingLabelInput from "./FloatingLabelInput"
import Fab from "@material-ui/core/Fab"
import VoiceOverOffIcon from "@material-ui/icons/VoiceOverOff"
import RecordVoiceOverIcon from "@material-ui/icons/RecordVoiceOver"
import CloseIcon from "@material-ui/icons/Close"
import CheckIcon from "@material-ui/icons/Check"
import Select from "react-select"
import ImageUploader from "react-images-upload"
import { Multiselect } from "multiselect-react-dropdown"
import ReactExport from "react-data-export"

const ExcelFile = ReactExport.ExcelFile
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn

const styleselect = {
      multiselectContainer: {
            // To change css for multiselect (Width,height,etc..)
            fontSize: "14px",
            border: "1.25px solid #bababa",
            borderRadius: "4px",
            marginTop: "15px",
      },
      searchBox: {
            // To change search box element look
            fontSize: "14px",
            minheight: "50px",
            textAlign: "right",
            padding: " 10px",
      },
      inputField: {
            // To change input field position or margin
            margin: "5px",
            fontSize: "14px",
      },
      chips: {
            // To change css chips(Selected options)
            //  background: '#00000000',
            border: "2px solid",
            fontSize: "14px",
      },
      optionContainer: {
            // To change css for option container
            textAlign: "right",
      },
      option: {
            // To change css for dropdown options
            fontSize: "14px",
            textAlign: "right",
      },
      groupHeading: {
            // To chanage group heading style
      },
}

const styles = (theme) => ({
      paperrtl: {
            marginTop: theme.spacing(0),
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
      },
      paper: {
            display: "flex",
            flexWrap: "wrap",
            "& > *": {
                  margin: theme.spacing(1),
                  width: theme.spacing(20),
            },
      },
      root: {
            width: "100%",
            margin: "15px",
            padding: "8px",
            direction: "rtl",
      },
      container: {
            maxHeight: 400,
      },
      large: {
            width: theme.spacing(10),
            height: theme.spacing(10),
      },
})

class ChangeKindOrganrequest extends Component {
      cookies = new Cookies()
      temp333
      constructor(props) {
            super(props)
            this.multiselectCompanyRef = React.createRef()
            this.multiselectFieldinsuranceRef = React.createRef()
            this.multiselectSendrequestKindRef = React.createRef()
            this.multiselectStateRef = React.createRef()
            this.multiselectCityRef = React.createRef()
            this.multiselectOrganRef = React.createRef()
            this.multiselectContractRef = React.createRef()

            this.state = {
                  redirect: false,
                  errstr: "",
                  errstatus: false,
                  okstatus: false,
                  requestinfos: [],
                  agentInfofilter: [],
                  rowsPerPage: 5,
                  page: 0,
                  kindorgansendrequest_id: "",
                  agent_code: "",
                  agent_name: "",
                  agent_family: "",
                  agent_mobile: "",
                  agent_tell: "",
                  agent_company_name: "",
                  agent_city_name: "",
                  agent_company_logo_url: "",
                  fieldinsurance_name: "",
                  fieldinsurance_logo_url: "",
                  orderBy: "kindorgansendrequest_id",
                  order: "desc",
                  snackstr: "",
                  showSnack: false,
                  snackMode: "success",
                  newKindOrganrequest: true,

                  optionAgent: [],
                  selectedAgent: "",

                  optionCompany: [],
                  optionFilterCompany: "",
                  selectedCompany: [{ value: "0", label: "" }],

                  optionFieldinsurance: [{ value: "0", label: "همه رشته ها" }],
                  optionFilterFieldinsurance: "",
                  selectedFieldinsurance: { value: "0", label: "همه رشته ها" },

                  optionSendrequestKind: [],
                  optionFilterSendrequestKind: "",
                  selectedSendrequestKind: "",
                  optionOrgan: [{ value: "0", label: "همه سازمان ها" }],
                  selectedOrgan: { value: "0", label: "همه سازمان ها" },
                  optionContract: [{ value: "0", label: "همه قراردادها" }],
                  optionFilterContract: [],
                  selectedContract: { value: "0", label: "همه قراردادها" },

                  optionState: [{ value: "0", label: "همه استانها" }],
                  selectedState: { value: "0", label: "همه استانها" },
                  optionCity: [{ value: "0", label: "همه شهرها" }],
                  optionFilterCity: [],
                  selectedCity: { value: "0", label: "همه شهرها" },

                  selectedFilterCompany: [],
                  selectedFilterSendrequestKind: [],
                  selectedFilterFieldinsurance: [],
                  selectedFilterState: [],
                  selectedFilterOrgan: [],
                  selectedFilterCity: [],
                  selectedFilterContract: [],
                  selectedFilterDeactive: "",
            }
      }

      handleClickcloseTasckBar = (event) => {
            this.setState({ showSnack: false })
      }

      handleSelectRows = (row2) => {
            console.log(row2.kindorgansendrequest_agent_id)
            this.setState(
                  {
                        kindorgansendrequest_id: row2.kindorgansendrequest_id,
                        newKindOrganrequest: false,
                        selectedCompany: { value: row2.company_id, label: row2.agent_company_name, logo: row2.agent_company_logo_url },
                        selectedFieldinsurance: {
                              value: row2.kindorgansendrequest_fieldinsurance_id,
                              label: row2.fieldinsurance_name,
                              logo: row2.fieldinsurance_logo_url,
                        },
                        selectedSendrequestKind: { value: row2.kindorgansendrequest_kind_id, label: row2.sendrequest_kind_name },
                        selectedState: { value: row2.kindorgansendrequest_state_id, label: row2.agent_state_name },
                        selectedOrgan: { value: row2.kindorgansendrequest_organ_id, label: row2.organ_name },
                        selectedCity: { value: row2.kindorgansendrequest_city_id, label: row2.agent_city_name },
                        selectedContract: { value: row2.kindorgansendrequest_contract_id, label: row2.organ_contract_num },
                        selectedAgent: {
                              value: row2.kindorgansendrequest_agent_id,
                              label: row2.agent_name + " " + row2.agent_family + "-" + row2.agent_mobile,
                              agent_status: row2.agent_status,
                              company_id: row2.company_id,
                        },
                  },
                  () => {
                        this.getoptionCityID()
                        this.getoptionContractID()
                  }
            )
      }

      newKindOrganrequestFunc = (event) => {
            this.setState({
                  kindorgansendrequest_id: "",
                  newKindOrganrequest: true,
                  selectedCompany: [{ value: "0", label: "" }],
                  selectedFieldinsurance: [{ value: "0", label: "همه شرکت ها" }],
                  selectedSendrequestKind: {},
                  selectedState: { value: "0", label: "همه استانها" },
                  selectedCity: { value: "0", label: "همه شهرها" },
                  selectedOrgan: { value: "0", label: "همه سازمان ها" },
                  selectedContract: { value: "0", label: "همه قرادادها" },
            })
      }

// ------------------------------------------------------------------------------------------------------------
  async    componentDidMount() {
            if (this.cookies.get("employee_token_str")) {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  })
                  var self = this
                  const response=await $POST(`employeelogin?command=checkemployeelogin`);
                  const arr=response.data;
                        if (response.status == 200) {

                              if (arr.result === "ok") {
                                    self.getKindOrganrequest()
                                    self.getoptionStateID()
                                    self.getoptionOrgan()
                                    self.getoptionCompany()
                                    self.getoptionFieldinsurance()
                                    self.getoptionSendrequestKind()
                                    self.getoptionAgent()
                              } else if (arr.result === "error") {
                                    self.setState({ redirect: true })
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
            } else {
                  this.setState({ redirect: true })
            }
      }

// ---------------------------------------------------------------------------------------------------------------
     async getKindOrganrequest() {
            this.props.props.props.dispatch({
                  type: "WAITSHOW",
            })
            var self = this
            const response=await $POST(`kindorgansendrequest?command=get_kindorgansendrequest`);
            const arr=response.data;
                  if (response.status == 200) {
                        console.log(arr)
                        if (arr.result === "ok") {
                              self.setState({ requestinfos: arr.data, agentInfofilter: arr.data }, () => {})
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        } else if (arr.result === "eror") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                        self.props.props.props.dispatch({
                              type: "WITEHIDE",
                        })
                  }
      }

// -------------------------------------------------------------------------------------------------------------------------

  async    getoptionCompany ()  {
            // post
            var self = this
            const response=await $POST(`company?command=get_company`);
            const arr=response.data;
                  if (response.status == 200) {
                        if (arr.result === "ok") {
                              var Company = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({
                                          value: arr.data[k].company_id,
                                          label: arr.data[k].company_name,
                                          logo: arr.data[k].company_logo_url,
                                    })
                              }
                              self.setState({ optionCompany: Company }, () => {})
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }

      }



// -----------------------------------------------------------------------------------------------------------------
      getoptionFieldinsurance =async () => {
            var self = this;
            const response=await $POST(`fieldinsurance?command=get_fieldinsurance`);
            const arr=response.data;
                  if (response.status == 200) {
                        if (arr.result === "ok") {
                              var Fieldinsurance = [{ value: "0", label: "همه رشته ها" }]
                              for (var k = 0; k < arr.data.length; k++) {
                                    Fieldinsurance.push({
                                          value: arr.data[k].fieldinsurance_id,
                                          label: arr.data[k].fieldinsurance_fa,
                                          logo: arr.data[k].fieldinsurance_logo_url,
                                    })
                              }
                              self.setState({ optionFieldinsurance: Fieldinsurance }, () => {})
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
      }
// -------------------------------------------------------------------------------------------------------------------------



      getoptionAgent = () => {
            const { selectedCompany } = this.state
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var State = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    State.push({
                                          value: arr.data[k].agent_id,
                                          label: arr.data[k].agent_name + " " + arr.data[k].agent_family + "-" + arr.data[k].agent_mobile,
                                          agent_status: arr.data[k].agent_status,
                                          company_id: arr.data[k].company_id,
                                    })
                              }
                              self.setState({ optionAgent: State })
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_agent")
            if (selectedCompany.value !== "0") {
                  fd.append("agent_company_id", selectedCompany.value)
            } //

            xhttp.open("POST", `${constants.BASE_URL}/agent`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }




      // --------------------------------------------------------------------------------------------------------
      getoptionSendrequestKind = async() => {
            var self = this
            const response=await $POST(`kindorgansendrequest?command=get_sendrequest_kind`);
            const arr=response.data;
                  if (response.status == 200) {
                        console.log(arr)
                        if (arr.result === "ok") {
                              var SendrequestKind = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    SendrequestKind.push({ value: arr.data[k].sendrequest_kind_id, label: arr.data[k].sendrequest_kind_name })
                              }
                              self.setState({ optionSendrequestKind: SendrequestKind, selectedSendrequestKind: SendrequestKind[0] }, () => {})
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
      }



      getoptionStateID =async () => {
            // post
            var self = this;
            const response=await $POST(`statecity?command=get_state`);
            const arr=response.data;
                  if (response.status == 200) {
                        if (arr.result === "ok") {
                              var State = [{ value: "0", label: "همه استانها" }]
                              for (var k = 0; k < arr.data.length; k++) {
                                    State.push({ value: arr.data[k].state_id, label: arr.data[k].state_name })
                              }
                              self.setState({ optionState: State }, () => {
                                    //   self.getoptionCityID();
                              })
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
         
      }




      getoptionOrgan = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Organ = [{ value: "0", label: "همه سازمانها" }]
                              for (var k = 0; k < arr.data.length; k++) {
                                    Organ.push({ value: arr.data[k].organ_id, label: arr.data[k].organ_name })
                              }
                              self.setState({ optionOrgan: Organ }, () => {
                                    //   self.getoptionCityID();
                              })
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_organ")
            xhttp.open("POST", `${constants.BASE_URL}/organ`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      getoptionCityID = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var State = [{ value: "0", label: "همه شهر ها" }]
                              for (var k = 0; k < arr.data.length; k++) {
                                    State.push({ value: arr.data[k].city_id, label: arr.data[k].city_name })
                              }
                              self.setState({ optionCity: State })
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_city")
            fd.append("state_id", this.state.selectedState.value)
            xhttp.open("POST", `${constants.BASE_URL}/statecity`)
            xhttp.send(fd)
      }

      getoptionContractID = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var State = [{ value: "0", label: "همه قرارداد ها" }]
                              for (var k = 0; k < arr.data.length; k++) {
                                    State.push({ value: arr.data[k].organ_contract_id, label: arr.data[k].organ_contract_num })
                              }
                              self.setState({ optionContract: State })
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_contract_byorgan")
            fd.append("organ_contract_organ_id", this.state.selectedOrgan.value)
            xhttp.open("POST", `${constants.BASE_URL}/organ`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      saveNewKindOrganrequest = () => {
            const {
                  selectedCompany,
                  selectedFieldinsurance,
                  selectedSendrequestKind,
                  selectedState,
                  selectedOrgan,
                  selectedCity,
                  selectedContract,
                  selectedAgent,
            } = this.state

            if (
                  selectedFieldinsurance.value == null ||
                  selectedCompany.value == null ||
                  selectedState.value == null ||
                  selectedOrgan.value == null ||
                  selectedCity.value == null ||
                  selectedContract.value == null ||
                  selectedAgent.value == null
            ) {
                  this.setState({ snackstr: "لطفا پارامتر های فرم را کامل نمایید", showSnack: true, snackMode: "error" })
            } else {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              console.log(arr)
                              if (arr.result === "ok") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                                    //self.setState({ redirect: true })
                                    self.getKindOrganrequest()
                                    self.newKindOrganrequestFunc()
                              } else if (arr.result === "error") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "add_kindorgansendrequest")

                  fd.append("kindorgansendrequest_company_id", selectedCompany.value)
                  fd.append("kindorgansendrequest_fieldinsurance_id", selectedFieldinsurance.value)
                  fd.append("kindorgansendrequest_kind_id", selectedSendrequestKind.value)
                  fd.append("kindorgansendrequest_state_id", selectedState.value)
                  fd.append("kindorgansendrequest_organ_id", selectedOrgan.value)
                  fd.append("kindorgansendrequest_city_id", selectedCity.value)
                  fd.append("kindorgansendrequest_contract_id", selectedContract.value)
                  fd.append("kindorgansendrequest_agent_id", selectedAgent.value)

                  xhttp.open("POST", `${constants.BASE_URL}/kindorgansendrequest`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            }
      }

      changeKindOrganrequest = () => {
            const {
                  kindorgansendrequest_id,
                  selectedCompany,
                  selectedFieldinsurance,
                  selectedSendrequestKind,
                  selectedState,
                  selectedOrgan,
                  selectedCity,
                  selectedContract,
                  selectedAgent,
            } = this.state

            this.props.props.props.dispatch({
                  type: "WAITSHOW",
            })

            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        console.log(this.responseText)
                        if (arr.result === "ok") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                              //self.setState({ redirect: true })
                              self.getKindOrganrequest()
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                        self.props.props.props.dispatch({
                              type: "WITEHIDE",
                        })
                  }
            }
            var fd = new FormData()
            fd.append("command", "modify_kindorgansendrequest")
            fd.append("kindorgansendrequest_id", kindorgansendrequest_id)
            fd.append("kindorgansendrequest_company_id", selectedCompany.value)
            console.log(selectedCompany)
            fd.append("kindorgansendrequest_fieldinsurance_id", selectedFieldinsurance.value)

            fd.append("kindorgansendrequest_kind_id", selectedSendrequestKind.value)
            fd.append("kindorgansendrequest_state_id", selectedState.value)
            fd.append("kindorgansendrequest_organ_id", selectedOrgan.value)
            fd.append("kindorgansendrequest_contract_id", selectedContract.value)
            fd.append("kindorgansendrequest_city_id", selectedCity.value)
            fd.append("kindorgansendrequest_agent_id", selectedAgent.value)

            xhttp.open("POST", `${constants.BASE_URL}/kindorgansendrequest`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      deletKindOrganrequest = () => {
            const { kindorgansendrequest_id } = this.state

            this.props.props.props.dispatch({
                  type: "WAITSHOW",
            })

            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                              //self.setState({ redirect: true })
                              self.getKindOrganrequest()
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                        self.props.props.props.dispatch({
                              type: "WITEHIDE",
                        })
                  }
            }
            var fd = new FormData()
            fd.append("command", "delete_kindorgansendrequest")
            fd.append("kindorgansendrequest_id", kindorgansendrequest_id)

            xhttp.open("POST", `${constants.BASE_URL}/kindorgansendrequest`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      createSortHandler = (field) => {
            if (this.state.orderBy === field) {
                  if (this.state.order === "asc") {
                        this.setState({ order: "desc" })
                  } else {
                        this.setState({ order: "asc" })
                  }
            } else {
                  this.setState({ orderBy: field, order: "asc" })
            }
            var arraytemp = [],
                  i,
                  j,
                  temp,
                  a,
                  b
            arraytemp = this.state.agentInfofilter
            for (i = 0; i < arraytemp.length; i++) {
                  for (j = 0; j < arraytemp.length - 1; j++) {
                        a = arraytemp[j]
                        b = arraytemp[j + 1]
                        if (a[field] < b[field] && this.state.order === "asc") {
                              temp = arraytemp[j]
                              arraytemp[j] = arraytemp[j + 1]
                              arraytemp[j + 1] = temp
                        } else if (a[field] > b[field] && this.state.order === "desc") {
                              temp = arraytemp[j]
                              arraytemp[j] = arraytemp[j + 1]
                              arraytemp[j + 1] = temp
                        }
                  }
            }
      }

      handleChangeRowsPerPage = (event) => {
            this.setState({ rowsPerPage: parseInt(event.target.value), page: 0 })
      }

      handleAgent = (selectedAgent) => {
            this.setState({ selectedAgent: selectedAgent })
      }
      handleChangePage = (event, number) => {
            this.setState({ page: parseInt(number, 0) })
      }

      handleState = (selectedState) => {
            this.setState({ selectedState: selectedState, selectedCity: { value: "0", label: "همه شهرها" } }, () => {
                  this.getoptionCityID()
            })
      }
      handleOrgan = (selectedOrgan) => {
            this.setState({ selectedOrgan: selectedOrgan, selectedContract: { value: "0", label: "همه قراردادها" } }, () => {
                  this.getoptionContractID()
            })
      }

      handleContract = (selectedContract) => {
            this.setState({ selectedContract: selectedContract }, () => {})
      }

      handleCity = (selectedCity) => {
            this.setState({ selectedCity: selectedCity }, () => {})
      }

      handleCompany = (selectedCompany) => {
            this.setState({ selectedCompany: selectedCompany }, () => {
                  this.getoptionAgent()
            })
      }

      handleFieldinsurance = (selectedFieldinsurance) => {
            this.setState({ selectedFieldinsurance: selectedFieldinsurance }, () => {})
      }

      handleSendrequestKind = (selectedSendrequestKind) => {
            this.setState({ selectedSendrequestKind: selectedSendrequestKind })
      }
      onSelectOptionSendrequestKind = (selectedList, selectedItem) => {
            this.setState(
                  {
                        selectedFilterSendrequestKind: selectedList,
                  },
                  () => {}
            )
      }

      onRemoveOptionSendrequestKind = (selectedList, removedItem) => {
            this.setState(
                  {
                        selectedFilterSendrequestKind: selectedList,
                  },
                  () => {}
            )
      }

      onSelectOptionCompany = (selectedList, selectedItem) => {
            this.setState(
                  {
                        selectedFilterCompany: selectedList,
                  },
                  () => {}
            )
      }

      onRemoveOptionCompany = (selectedList, removedItem) => {
            this.setState(
                  {
                        selectedFilterCompany: selectedList,
                  },
                  () => {}
            )
      }

      onSelectOptionFieldinsurance = (selectedList, selectedItem) => {
            this.setState(
                  {
                        selectedFilterFieldinsurance: selectedList,
                  },
                  () => {}
            )
      }

      onRemoveOptionFieldinsurance = (selectedList, removedItem) => {
            this.setState(
                  {
                        selectedFilterFieldinsurance: selectedList,
                  },
                  () => {}
            )
      }

      onSelectOptionCity = (selectedList, selectedItem) => {
            this.setState(
                  {
                        selectedFilterCity: selectedList,
                  },
                  () => {}
            )
      }

      onRemoveOptionCity = (selectedList, removedItem) => {
            this.setState(
                  {
                        selectedFilterCity: selectedList,
                  },
                  () => {}
            )
      }
      onSelectOptionState = (selectedList, selectedItem) => {
            this.setState(
                  {
                        selectedFilterState: selectedList,
                  },
                  () => {
                        this.getOptionFilterCity()
                  }
            )
      }

      onRemoveOptionState = (selectedList, removedItem) => {
            this.setState(
                  {
                        selectedFilterState: selectedList,
                  },
                  () => {
                        this.getOptionFilterCity()
                  }
            )
      }

      onSelectOptionContract = (selectedList, selectedItem) => {
            this.setState(
                  {
                        selectedFilterContract: selectedList,
                  },
                  () => {}
            )
      }

      onRemoveOptionContract = (selectedList, removedItem) => {
            this.setState(
                  {
                        selectedFilterContract: selectedList,
                  },
                  () => {}
            )
      }

      onSelectOptionOrgan = (selectedList, selectedItem) => {
            this.setState(
                  {
                        selectedFilterOrgan: selectedList,
                  },
                  () => {
                        this.getOptionFilterContract()
                  }
            )
      }

      onRemoveOptionOrgan = (selectedList, removedItem) => {
            this.setState(
                  {
                        selectedFilterOrgan: selectedList,
                  },
                  () => {
                        this.getOptionFilterContract()
                  }
            )
      }

      getOptionFilterCity = () => {
            const { selectedFilterState, optionState } = this.state
            this.setState({ optionFilterCity: [] }, () => {
                  for (var i = 0; i < selectedFilterState.length; i++) {
                        this.getCity(selectedFilterState[i].value)
                  }
            })
      }

      getOptionFilterContract = () => {
            const { selectedFilterOrgan, optionState } = this.state
            this.setState({ optionFilterContract: [] }, () => {
                  for (var i = 0; i < selectedFilterOrgan.length; i++) {
                        this.getContract(selectedFilterOrgan[i].value)
                  }
            })
      }

      getCity = (state_id) => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var State
                              if (self.state.optionFilterCity.length > 0) {
                                    var State = self.state.optionFilterCity
                              } else {
                                    var State = []
                              }
                              for (var k = 0; k < arr.data.length; k++) {
                                    State.push({ value: arr.data[k].city_id, label: arr.data[k].city_name })
                              }
                              self.setState({ optionFilterCity: State })
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_city")
            fd.append("state_id", state_id)
            xhttp.open("POST", `${constants.BASE_URL}/statecity`)
            xhttp.send(fd)
      }

      getContract = (organ_id) => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Contract
                              if (self.state.optionFilterContract.length > 0) {
                                    var Contract = self.state.optionFilterContract
                              } else {
                                    var Contract = []
                              }
                              for (var k = 0; k < arr.data.length; k++) {
                                    Contract.push({ value: arr.data[k].organ_contract_id, label: arr.data[k].organ_contract_num })
                              }
                              self.setState({ optionFilterContract: Contract })
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_contract_byorgan")
            fd.append("organ_contract_organ_id", organ_id)
            xhttp.open("POST", `${constants.BASE_URL}/organ`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      filterFunc = () => {
            const {
                  requestinfos,
                  agentInfofilter,
                  selectedFilterState,
                  selectedFilterOrgan,
                  selectedFilterCity,
                  selectedFilterContract,
                  selectedFilterCompany,
                  selectedFilterFieldinsurance,
                  selectedFilterSendrequestKind,
            } = this.state
            var i, j, temparray2, temparray, b1, b2, b3, b4, b5
            temparray = requestinfos
            temparray2 = []
            for (i = 0; i < requestinfos.length; i++) {
                  b1 = false
                  b2 = false
                  b3 = false
                  b4 = false

                  if (selectedFilterState.length === 0) {
                        b1 = true
                  } else {
                        for (j = 0; j < selectedFilterState.length; j++) {
                              if (temparray[i].kindorgansendrequest_state_id === selectedFilterState[j].value) {
                                    b1 = true
                              }
                        }
                  }

                  if (selectedFilterOrgan.length === 0) {
                        b1 = true
                  } else {
                        for (j = 0; j < selectedFilterOrgan.length; j++) {
                              if (temparray[i].kindorgansendrequest_organ_id === selectedFilterOrgan[j].value) {
                                    b1 = true
                              }
                        }
                  }

                  if (selectedFilterContract.length === 0) {
                        b2 = true
                  } else {
                        for (j = 0; j < selectedFilterContract.length; j++) {
                              if (temparray[i].kindorgansendrequest_contract_id === selectedFilterContract[j].value) {
                                    b2 = true
                              }
                        }
                  }

                  if (selectedFilterCity.length === 0) {
                        b2 = true
                  } else {
                        for (j = 0; j < selectedFilterCity.length; j++) {
                              if (temparray[i].kindorgansendrequest_city_id === selectedFilterCity[j].value) {
                                    b2 = true
                              }
                        }
                  }
                  if (selectedFilterCompany.length === 0) {
                        b3 = true
                  } else {
                        for (j = 0; j < selectedFilterCompany.length; j++) {
                              if (temparray[i].kindorgansendrequest_company_id === selectedFilterCompany[j].value) {
                                    b3 = true
                              }
                        }
                  }

                  if (selectedFilterFieldinsurance.length === 0) {
                        b5 = true
                  } else {
                        for (j = 0; j < selectedFilterFieldinsurance.length; j++) {
                              if (temparray[i].kindorgansendrequest_fieldinsurance_id === selectedFilterFieldinsurance[j].value) {
                                    b5 = true
                              }
                        }
                  }

                  if (selectedFilterSendrequestKind.length === 0) {
                        b4 = true
                  } else {
                        for (j = 0; j < selectedFilterSendrequestKind.length; j++) {
                              if (temparray[i].kindorgansendrequest_kind_id === selectedFilterSendrequestKind[j].value) {
                                    b4 = true
                              }
                        }
                  }

                  if (b1 && b2 && b3 && b4 && b5) {
                        temparray2.push(temparray[i])
                  }
            }
            this.setState({ agentInfofilter: temparray2 }, () => {})
      }
      ClearFilter = () => {
            this.setState({
                  selectedFilterCompany: [],
                  selectedFilterFieldinsurance: [],
                  selectedFilterSendrequestKind: [],
                  selectedFilterState: [],
                  selectedOptionState: [],
                  selectedFilterCity: [],
                  optionFilterCity: [],
                  selectedOptionCity: [],
                  selectedOptionOrgan: [],
                  selectedFilterOrgan: [],
                  selectedFilterContract: [],
                  optionFilterContract: [],
                  selectedOptionContract: [],

                  agentInfofilter: this.state.requestinfos,
            })
            this.multiselectCompanyRef.current.resetSelectedValues()
            this.multiselectFieldinsuranceRef.current.resetSelectedValues()
            this.multiselectSendrequestKindRef.current.resetSelectedValues()
            this.multiselectStateRef.current.resetSelectedValues()
            this.multiselectOrganRef.current.resetSelectedValues()
            this.multiselectContractRef.current.resetSelectedValues()
            this.multiselectCityRef.current.resetSelectedValues()
      }

      render() {
            const { classes } = this.props
            const {
                  selectedAgent,
                  optionAgent,
                  optionCity,
                  optionFilterCity,
                  selectedCity,
                  optionContract,
                  optionFilterContract,
                  selectedContract,
                  optionCompany,
                  selectedCompany,
                  optionFieldinsurance,
                  selectedFieldinsurance,
                  optionSendrequestKind,
                  selectedSendrequestKind,
                  optionState,
                  selectedState,
                  optionOrgan,
                  selectedOrgan,
                  snackMode,
                  snackstr,
                  showSnack,
                  newKindOrganrequest,
                  kindorgansendrequest_id,
                  agent_company_logo_url,
                  order,
                  orderBy,
                  okstatus,
                  errstr,
                  redirect,
                  agentInfofilter,
                  rowsPerPage,
                  page,
            } = this.state
            if (redirect) {
                  return <Redirect to="/" />
            } else {
                  return (
                        <div className={classes.paperrtl} dir="ltr">
                              <Snackbar
                                    anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                                    onClose={this.handleClickcloseTasckBar}
                                    open={showSnack}
                                    autoHideDuration={10000}
                              >
                                    <Alert severity={snackMode}>{snackstr}</Alert>
                              </Snackbar>
                              <Grid container spacing={3}>
                                    <Grid item xs={12}>
                                          <Container component="main" maxWidth="lg">
                                                <Paper elevation={4} className={classes.root}>
                                                      <Grid container spacing={3}>
                                                            <Grid item xs={6}>
                                                                  <Typography align="center" variant="h7">
                                                                        {"آی دی روش توزیع : " + kindorgansendrequest_id}
                                                                  </Typography>
                                                            </Grid>
                                                            <Grid item xs={6}></Grid>

                                                            <Grid item xs={6}>
                                                                  <div>
                                                                        <label className="on">استان</label>
                                                                        <Select
                                                                              isSearchable={true}
                                                                              className="adapter-txtsize"
                                                                              placeholder={"استان"}
                                                                              value={selectedState}
                                                                              onChange={this.handleState}
                                                                              options={optionState}
                                                                        />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <div>
                                                                        <label className="on">شهر</label>
                                                                        <Select
                                                                              isSearchable={true}
                                                                              className="adapter-txtsize"
                                                                              placeholder={"شهر"}
                                                                              value={selectedCity}
                                                                              onChange={this.handleCity}
                                                                              options={optionCity}
                                                                        />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <div>
                                                                        <label className="on">سازمان</label>
                                                                        <Select
                                                                              isSearchable={true}
                                                                              className="adapter-txtsize"
                                                                              placeholder={"سازمان"}
                                                                              value={selectedOrgan}
                                                                              onChange={this.handleOrgan}
                                                                              options={optionOrgan}
                                                                        />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <div>
                                                                        <label className="on">قرارداد</label>
                                                                        <Select
                                                                              isSearchable={true}
                                                                              className="adapter-txtsize"
                                                                              placeholder={"قرارداد"}
                                                                              value={selectedContract}
                                                                              onChange={this.handleContract}
                                                                              options={optionContract}
                                                                        />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={4}>
                                                                  <div>
                                                                        <label className="on">شرکت بیمه</label>
                                                                        <Select
                                                                              isSearchable={true}
                                                                              className="adapter-txtsize"
                                                                              placeholder={"شرکت بیمه"}
                                                                              value={selectedCompany}
                                                                              onChange={this.handleCompany}
                                                                              options={optionCompany}
                                                                        />
                                                                  </div>
                                                            </Grid>
                                                            <Grid item xs={2}>
                                                                  <div style={{ width: "100%", textAlign: "center" }}>
                                                                        <img alt="Remy Sharp" style={{ width: "25%" }} src={selectedCompany.logo} />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={4}>
                                                                  <div>
                                                                        <label className="on">رشته بیمه</label>
                                                                        <Select
                                                                              isSearchable={true}
                                                                              className="adapter-txtsize"
                                                                              placeholder={"رشته بیمه"}
                                                                              value={selectedFieldinsurance}
                                                                              onChange={this.handleFieldinsurance}
                                                                              options={optionFieldinsurance}
                                                                        />
                                                                  </div>
                                                            </Grid>
                                                            <Grid item xs={2}>
                                                                  <div style={{ width: "100%", textAlign: "center" }}>
                                                                        <img
                                                                              alt="Remy Sharp"
                                                                              style={{ width: "25%" }}
                                                                              src={selectedFieldinsurance.logo}
                                                                        />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <div>
                                                                        <label className="on">نوع توزیع </label>
                                                                        <Select
                                                                              isSearchable={true}
                                                                              className="adapter-txtsize"
                                                                              placeholder={" نوع توزیع"}
                                                                              value={selectedSendrequestKind}
                                                                              onChange={this.handleSendrequestKind}
                                                                              options={optionSendrequestKind}
                                                                        />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <div>
                                                                        <label className="on">نماینده</label>
                                                                        <Select
                                                                              isSearchable={true}
                                                                              className="adapter-txtsize"
                                                                              placeholder={"نماینده"}
                                                                              value={selectedAgent}
                                                                              onChange={this.handleAgent}
                                                                              options={optionAgent}
                                                                        />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  {newKindOrganrequest ? (
                                                                        <Button
                                                                              variant="outlined"
                                                                              color="primary"
                                                                              onClick={(e) => {
                                                                                    this.saveNewKindOrganrequest()
                                                                              }}
                                                                        >
                                                                              {"ثبت روش توزیع جدید "}
                                                                        </Button>
                                                                  ) : (
                                                                        <div style={{ width: "100%", textAlign: "right" }}>
                                                                              <Button
                                                                                    variant="outlined"
                                                                                    color="primary"
                                                                                    onClick={this.newKindOrganrequestFunc}
                                                                              >
                                                                                    {"روش توزیع جدید"}
                                                                              </Button>
                                                                              {"          "}
                                                                              <Button
                                                                                    variant="outlined"
                                                                                    color="primary"
                                                                                    onClick={(e) => {
                                                                                          this.changeKindOrganrequest()
                                                                                    }}
                                                                              >
                                                                                    {"ثبت تغییرات"}
                                                                              </Button>
                                                                              {"          "}
                                                                              <Button
                                                                                    variant="outlined"
                                                                                    color="primary"
                                                                                    onClick={(e) => {
                                                                                          this.deletKindOrganrequest()
                                                                                    }}
                                                                              >
                                                                                    {"حذف روش"}
                                                                              </Button>
                                                                        </div>
                                                                  )}
                                                            </Grid>
                                                      </Grid>
                                                </Paper>
                                          </Container>
                                    </Grid>

                                    <Grid item xs={12}>
                                          <Container component="main" maxWidth="lg">
                                                <Paper elevation={4} className={classes.root}>
                                                      <Grid container spacing={3}>
                                                            <Grid item xs={12}>
                                                                  <Divider />
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <div style={{ width: "100%", textAlign: "center" }}>
                                                                        <Multiselect
                                                                              style={styleselect}
                                                                              options={optionCompany} // Options to display in the dropdown
                                                                              //selectedValues={selectedOptionCompany} // Preselected value to persist in dropdown
                                                                              onSelect={this.onSelectOptionCompany} // Function will trigger on select event
                                                                              onRemove={this.onRemoveOptionCompany} // Function will trigger on remove event
                                                                              ref={this.multiselectCompanyRef}
                                                                              displayValue="label" // Property name to display in the dropdown options
                                                                              placeholder="شرکت بیمه"
                                                                              closeIcon="circle2"
                                                                              emptyRecordMsg="فیلد  در دسترس نیست "
                                                                        />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <div style={{ width: "100%", textAlign: "center" }}>
                                                                        <Multiselect
                                                                              style={styleselect}
                                                                              options={optionFieldinsurance} // Options to display in the dropdown
                                                                              //selectedValues={selectedOptionFieldinsurance} // Preselected value to persist in dropdown
                                                                              onSelect={this.onSelectOptionFieldinsurance} // Function will trigger on select event
                                                                              onRemove={this.onRemoveOptionFieldinsurance} // Function will trigger on remove event
                                                                              ref={this.multiselectFieldinsuranceRef}
                                                                              displayValue="label" // Property name to display in the dropdown options
                                                                              placeholder="رشته بیمه"
                                                                              closeIcon="circle2"
                                                                              emptyRecordMsg="فیلد  در دسترس نیست "
                                                                        />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <div style={{ width: "100%", textAlign: "center" }}>
                                                                        <Multiselect
                                                                              style={styleselect}
                                                                              options={optionSendrequestKind} // Options to display in the dropdown
                                                                              //selectedValues={selectedOptionCompany} // Preselected value to persist in dropdown
                                                                              onSelect={this.onSelectOptionSendrequestKind} // Function will trigger on select event
                                                                              onRemove={this.onRemoveOptionSendrequestKind} // Function will trigger on remove event
                                                                              ref={this.multiselectSendrequestKindRef}
                                                                              displayValue="label" // Property name to display in the dropdown options
                                                                              placeholder="نوع توزیع"
                                                                              closeIcon="circle2"
                                                                              emptyRecordMsg="فیلد  در دسترس نیست "
                                                                        />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <div style={{ width: "100%", textAlign: "center" }}>
                                                                        <Multiselect
                                                                              style={styleselect}
                                                                              options={optionState} // Options to display in the dropdown
                                                                              //selectedValues={selectedOptionState} // Preselected value to persist in dropdown
                                                                              onSelect={this.onSelectOptionState} // Function will trigger on select event
                                                                              onRemove={this.onRemoveOptionState} // Function will trigger on remove event
                                                                              ref={this.multiselectStateRef}
                                                                              displayValue="label" // Property name to display in the dropdown options
                                                                              placeholder="استان ها "
                                                                              closeIcon="circle2"
                                                                              emptyRecordMsg="فیلد  در دسترس نیست "
                                                                        />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <div style={{ width: "100%", textAlign: "center" }}>
                                                                        <Multiselect
                                                                              style={styleselect}
                                                                              options={optionFilterCity} // Options to display in the dropdown
                                                                              //selectedValues={selectedOptionCity} // Preselected value to persist in dropdown
                                                                              onSelect={this.onSelectOptionCity} // Function will trigger on select event
                                                                              onRemove={this.onRemoveOptionCity} // Function will trigger on remove event
                                                                              ref={this.multiselectCityRef}
                                                                              displayValue="label" // Property name to display in the dropdown options
                                                                              placeholder="شهر ها "
                                                                              closeIcon="circle2"
                                                                              emptyRecordMsg="فیلد  در دسترس نیست "
                                                                        />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <div style={{ width: "100%", textAlign: "center" }}>
                                                                        <Multiselect
                                                                              style={styleselect}
                                                                              options={optionOrgan} // Options to display in the dropdown
                                                                              //selectedValues={selectedOptionOrgan} // Preselected value to persist in dropdown
                                                                              onSelect={this.onSelectOptionOrgan} // Function will trigger on select event
                                                                              onRemove={this.onRemoveOptionOrgan} // Function will trigger on remove event
                                                                              ref={this.multiselectOrganRef}
                                                                              displayValue="label" // Property name to display in the dropdown options
                                                                              placeholder="استان ها "
                                                                              closeIcon="circle2"
                                                                              emptyRecordMsg="فیلد  در دسترس نیست "
                                                                        />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <div style={{ width: "100%", textAlign: "center" }}>
                                                                        <Multiselect
                                                                              style={styleselect}
                                                                              options={optionFilterContract} // Options to display in the dropdown
                                                                              //selectedValues={selectedOptionContract} // Preselected value to persist in dropdown
                                                                              onSelect={this.onSelectOptionContract} // Function will trigger on select event
                                                                              onRemove={this.onRemoveOptionContract} // Function will trigger on remove event
                                                                              ref={this.multiselectContractRef}
                                                                              displayValue="label" // Property name to display in the dropdown options
                                                                              placeholder="قرارداد ها "
                                                                              closeIcon="circle2"
                                                                              emptyRecordMsg="فیلد  در دسترس نیست "
                                                                        />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={3}>
                                                                  <Button variant="outlined" color="primary" onClick={this.filterFunc}>
                                                                        {"جستجو "}
                                                                  </Button>
                                                            </Grid>
                                                            <Grid item xs={3}>
                                                                  <Button variant="outlined" color="primary" onClick={this.ClearFilter}>
                                                                        {"پاک کردن فیلتر ها "}
                                                                  </Button>
                                                            </Grid>
                                                            <Grid item xs={12}>
                                                                  <Divider />
                                                            </Grid>
                                                      </Grid>
                                                </Paper>
                                          </Container>
                                    </Grid>

                                    <Grid item xs={12}>
                                          <Container maxWidth="lg">
                                                <Paper className={classes.root}>
                                                      <TableContainer dir="rtl">
                                                            <Table aria-label="sticky table">
                                                                  <TableHead>
                                                                        <TableRow>
                                                                              <TableCell>
                                                                                    <ExcelFile
                                                                                          element={
                                                                                                <Button variant="outlined" color="primary">
                                                                                                      {" "}
                                                                                                      {"اکسل "}
                                                                                                </Button>
                                                                                          }
                                                                                    >
                                                                                          <ExcelSheet data={agentInfofilter} name="نمایندگان">
                                                                                                <ExcelColumn
                                                                                                      label="آی دی"
                                                                                                      value="kindorgansendrequest_id"
                                                                                                />
                                                                                                <ExcelColumn
                                                                                                      label="استان "
                                                                                                      value="agent_state_name"
                                                                                                />
                                                                                                <ExcelColumn label="شهر " value="agent_city_name" />
                                                                                                <ExcelColumn
                                                                                                      label="سازمان "
                                                                                                      value="agent_organ_name"
                                                                                                />
                                                                                                <ExcelColumn
                                                                                                      label="قرارداد "
                                                                                                      value="organ_contract_num"
                                                                                                />
                                                                                                <ExcelColumn
                                                                                                      label="شرکت بیمه"
                                                                                                      value="agent_company_name"
                                                                                                />
                                                                                                <ExcelColumn
                                                                                                      label="رشته بیمه"
                                                                                                      value="fieldinsurance_name"
                                                                                                />
                                                                                                <ExcelColumn
                                                                                                      label="نوع توزیع"
                                                                                                      value="sendrequest_kind_name"
                                                                                                />
                                                                                                <ExcelColumn label="جنسیت" value="agent_gender" />
                                                                                                <ExcelColumn label="نام" value="agent_name" />
                                                                                                <ExcelColumn
                                                                                                      label="نام خانوادگی"
                                                                                                      value="agent_family"
                                                                                                />
                                                                                                <ExcelColumn
                                                                                                      label="شماره همراه"
                                                                                                      value="agent_mobile"
                                                                                                />
                                                                                                <ExcelColumn label="کد نمایندگی" value="agent_code" />
                                                                                          </ExcelSheet>
                                                                                    </ExcelFile>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"agent_state_name"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"استان"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "agent_state_name"}
                                                                                          direction={orderBy === "agent_state_name" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("agent_state_name")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"agent_city_name"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"شهر"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "agent_city_name"}
                                                                                          direction={orderBy === "agent_city_name" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("agent_city_name")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>
                                                                              <TableCell key={"Organ_name"} align={"center"} style={{ minWidth: 60 }}>
                                                                                    {"نام سازمان"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "organ_name"}
                                                                                          direction={orderBy === "organ_name" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("organ_name")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"organ_contract_num"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"شماره قرارداد"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "organ_contract_num"}
                                                                                          direction={orderBy === "organ_contract_num" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("organ_contract_num")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"agent_company_name"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"شرکت بیمه"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "agent_company_name"}
                                                                                          direction={orderBy === "agent_company_name" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("agent_company_name")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"fieldinsurance_name"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"رشته بیمه"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "fieldinsurance_name"}
                                                                                          direction={
                                                                                                orderBy === "fieldinsurance_name" ? order : "asc"
                                                                                          }
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("fieldinsurance_name")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>
                                                                              <TableCell
                                                                                    key={"kindorgansendrequest_kind_id"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 20 }}
                                                                                    sortDirection={
                                                                                          orderBy === "kindorgansendrequest_kind_id" ? order : false
                                                                                    }
                                                                              >
                                                                                    {"نوع ارجاع"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "kindorgansendrequest_kind_id"}
                                                                                          direction={
                                                                                                orderBy === "kindorgansendrequest_kind_id"
                                                                                                      ? order
                                                                                                      : "asc"
                                                                                          }
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("kindorgansendrequest_kind_id")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell key={"agent_name"} align={"center"} style={{ minWidth: 60 }}>
                                                                                    {"نام و نام خانوادگی "}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "agent_name"}
                                                                                          direction={orderBy === "agent_name" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("agent_name")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"agent_mobile"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {" شماره همراه "}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "agent_mobile"}
                                                                                          direction={orderBy === "agent_mobile" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("agent_mobile")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>
                                                                        </TableRow>
                                                                  </TableHead>

                                                                  <TableBody>
                                                                        {agentInfofilter
                                                                              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                                              .map((row) => {
                                                                                    return (
                                                                                          <TableRow
                                                                                                hover
                                                                                                role="checkbox"
                                                                                                tabIndex={-1}
                                                                                                key={row["kindorgansendrequest_id"]}
                                                                                                value={row}
                                                                                                onClick={() => {
                                                                                                      this.handleSelectRows(row)
                                                                                                }}
                                                                                          >
                                                                                                <TableCell
                                                                                                      key={"kindorgansendrequest_id"}
                                                                                                      align={"center"}
                                                                                                >
                                                                                                      {row["kindorgansendrequest_id"]}
                                                                                                </TableCell>

                                                                                                <TableCell key={"agent_state_name"} align={"center"}>
                                                                                                      {row["agent_state_name"]}
                                                                                                </TableCell>

                                                                                                <TableCell key={"agent_city_name"} align={"center"}>
                                                                                                      {row["agent_city_name"]}
                                                                                                </TableCell>

                                                                                                <TableCell key={"organ_name"} align={"center"}>
                                                                                                      {row["organ_name"]}
                                                                                                </TableCell>

                                                                                                <TableCell
                                                                                                      key={"organ_contract_num"}
                                                                                                      align={"center"}
                                                                                                >
                                                                                                      {row["organ_contract_num"]}
                                                                                                </TableCell>

                                                                                                <TableCell
                                                                                                      key={"agent_company_name"}
                                                                                                      align={"center"}
                                                                                                >
                                                                                                      {row["agent_company_name"]}
                                                                                                </TableCell>

                                                                                                <TableCell
                                                                                                      key={"fieldinsurance_name"}
                                                                                                      align={"center"}
                                                                                                >
                                                                                                      {row["fieldinsurance_name"]}
                                                                                                </TableCell>

                                                                                                <TableCell
                                                                                                      key={"sendrequest_kind_name"}
                                                                                                      align={"center"}
                                                                                                >
                                                                                                      {row["sendrequest_kind_name"]}
                                                                                                </TableCell>

                                                                                                <TableCell key={"agent_name"} align={"center"}>
                                                                                                      {row["agent_name"] + " " + row["agent_family"]}
                                                                                                </TableCell>

                                                                                                <TableCell key={"agent_mobile"} align={"center"}>
                                                                                                      {row["agent_mobile"]}
                                                                                                </TableCell>
                                                                                          </TableRow>
                                                                                    )
                                                                              })}
                                                                  </TableBody>
                                                            </Table>
                                                      </TableContainer>
                                                      <TablePagination
                                                            rowsPerPageOptions={[5, 10, 25, 100]}
                                                            component="div"
                                                            count={agentInfofilter.length}
                                                            rowsPerPage={rowsPerPage}
                                                            page={page}
                                                            onChangePage={this.handleChangePage}
                                                            onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                                      />
                                                </Paper>
                                          </Container>
                                    </Grid>
                              </Grid>

                              {okstatus ? (
                                    <Alert severity="success">
                                          <AlertTitle>پیام</AlertTitle>
                                          {errstr}
                                    </Alert>
                              ) : null}
                        </div>
                  )
            }
      }
}

export default withStyles(styles)(ChangeKindOrganrequest)
